module.exports = __webpack_public_path__ + "img/meetingsummary.6a70040a.png";